import React, { useState } from 'react'
import HardwareInfo from '../Hardware/HardwareInfo';
import { SubNav } from '../layout/submenu';
import { DataTable } from '../widgets'

const BoardRow = (props) => {
    const { index, board, selectedHardware, handleBoardList, isAllowEdit } = props;
    const hardwareName = board.hardware_name;
    const hardware_uuid = board.hardware_uuid;
    const serialNumber = board.current_hardware_info.imei;
    const installedIn = board.current_hardware_info.equipment_group_name
        ? board.current_hardware_info.equipment_group_name : "";

    const [boardModal, setBoardModal] = useState(false);

    const formatFarmStatus = (farmItem, index) => {
        return <span key={index}
            className={`my-1 badge badge-pill ${farmItem.is_current_active_farm ? "badge-success" : "badge-secondary"} badge-sm mr-2`}>
            {farmItem.farm_name}
        </span>
    };

    return (
        <>
            <DataTable.Row>
                <DataTable.Cell style={{ width: "60px" }}>{index}</DataTable.Cell>
                <DataTable.Cell style={{ width: "160px" }}>{hardwareName}</DataTable.Cell>
                <DataTable.Cell >
                    {board.farm_list.sort((a, b) => b.is_current_active_farm - a.is_current_active_farm)
                        .map((farmItem, i) => formatFarmStatus(farmItem, i))}
                </DataTable.Cell>
                <DataTable.Cell style={{ width: "240px" }}>{installedIn}</DataTable.Cell>
                <DataTable.Cell style={{ width: "280px" }}>{serialNumber}</DataTable.Cell>
                <DataTable.Cell style={{ width: "120px", textAlign: 'center', cursor: "pointer"}}>
                    <i className="fa fa-cogs" title="See Details" aria-hidden="true"
                        onClick={() => setBoardModal(true)}></i>
                </DataTable.Cell>
                {isAllowEdit && <DataTable.Cell width="45px">
                    <SubNav.Checkbox
                        className="square"
                        checked={selectedHardware.includes(hardware_uuid)}
                        onChange={(e) => handleBoardList(hardware_uuid, e)}
                    />
                </DataTable.Cell>}
            </DataTable.Row>
            {boardModal &&
                <HardwareInfo
                    show={true}
                    onHide={() => setBoardModal(false)}
                    hardwareId={hardware_uuid}
                    hardwareInfo={board}
                />}
        </>
    )
}

export default BoardRow
